import { t } from "@/i18n-js/instance";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";

export interface RemovePropertyButtonProps {
  label?: string;
  onClick: () => void;
}

export const RemovePropertyButton = ({
  onClick,
  label = t("builder_ui.editor.remove_property"),
}: RemovePropertyButtonProps) => (
  <TippyV2 content={label}>
    <IconButton
      name="16-minus"
      ariaLabel={label}
      onClick={onClick}
      className="rounded-full"
    />
  </TippyV2>
);
